/* import __COLOCATED_TEMPLATE__ from './disabled-icon.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./disabled-icon.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({
  tagName: "span",
  classNameBindings: [":fa-stack"]
}));